import React from "react";
import { colourClasses } from "@/lib/colours";

const STOCK_STATUS = {
  in_stock: { colour: "green", label: "In Stock" },
  low_stock: { colour: "amber", label: "Low Stock" },
  out_of_stock: { colour: "red", label: "Out of Stock" },
  unlimited: { colour: "blue", label: "Unlimited" },
};

export function StockStatusPill({ status }) {
  const s = STOCK_STATUS[status] || { colour: "grey", label: status || "—" };
  const c = colourClasses(s.colour);
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap ${c.bg} ${c.text} ${c.border}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />{s.label}
    </span>
  );
}

// Stock remaining cell: shows "Unlimited" for artificial service quantities.
export function StockValue({ row }) {
  if (row.unlimited_quantity) {
    const c = colourClasses("blue");
    return <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold ${c.bg} ${c.text}`}>Unlimited</span>;
  }
  const n = Number(row.total_stock) || 0;
  const c = colourClasses(n > 0 ? "green" : "grey");
  return <span className={`inline-flex items-center justify-center min-w-[28px] px-1.5 py-0.5 rounded-md text-xs font-semibold ${c.bg} ${c.text}`}>{n}</span>;
}
